import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getDuration(state: RootState): FlightCalendarsFiltersState['duration'] {
  const { duration } = state.flightCalendars.filtersValues;
  return duration;
}

export default getDuration;
